import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
export const GetCountStepsTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            CountStepsTID: {
                HelpCenterLink: 'count-help-center-link'
            }
        }
    });
export const CountSteps = ()=>{
    const { t: countTexts } = useLocaleKeys('integrations.setup.count');
    const { CountStepsTID } = useMemo(()=>GetCountStepsTID(), []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: countTexts.stepOpenIntegrations()
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: countTexts.stepPasteApiKey()
            }),
            /*#__PURE__*/ _jsx(ExternalLinkButton, {
                href: "http://help.sayanchor.com/en/articles/13737208-count",
                openInNewTab: true,
                style: {
                    marginTop: 16
                },
                testId: CountStepsTID.HelpCenterLink(),
                bi: {
                    name: 'count_help_center_link'
                },
                children: countTexts.readMoreInHelpCenter()
            })
        ]
    });
};
